<script setup></script>

<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="207" height="145" viewBox="0 0 207 145" fill="none">
    <g clip-path="url(#clip0_6686_46763)">
      <mask
        id="mask0_6686_46763"
        style="mask-type: luminance"
        maskUnits="userSpaceOnUse"
        x="0"
        y="0"
        width="207"
        height="145"
      >
        <path d="M207 0H0V145H207V0Z" fill="white" />
      </mask>
      <g mask="url(#mask0_6686_46763)">
        <path d="M207 0H0V145H207V0Z" fill="white" />
        <path
          d="M75.1379 59.7854V122.954H1.33057V33.5938H48.9978L75.1379 59.7854Z"
          fill="white"
          stroke="currentColor"
          stroke-width="3.04348"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M75.1369 59.7854H48.9968V33.5938"
          stroke="currentColor"
          stroke-width="3.04348"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.2441 104.467H58.2231"
          stroke="currentColor"
          stroke-width="3.04348"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.2441 89.0576H58.2231"
          stroke="currentColor"
          stroke-width="3.04348"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.2441 73.6523H58.2231"
          stroke="currentColor"
          stroke-width="3.04348"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M18.2441 58.2422H35.1583"
          stroke="currentColor"
          stroke-width="3.04348"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M151.386 43.3207V142.993H34.9258V1.99316H110.139L151.386 43.3207Z"
          fill="white"
          stroke="currentColor"
          stroke-width="3.04348"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M151.636 43.3207H110.39V1.99316"
          stroke="currentColor"
          stroke-width="3.04348"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M53.6382 123H79.792"
          stroke="#FF531A"
          stroke-width="3.04348"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M53.1567 59.0352H116.239"
          stroke="currentColor"
          stroke-width="3.04348"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M53.1567 29.6445H79.8455"
          stroke="currentColor"
          stroke-width="3.04348"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M53.1567 44.7383H79.8455"
          stroke="currentColor"
          stroke-width="3.04348"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M53.1567 72.6191H117.772"
          stroke="currentColor"
          stroke-width="3.04348"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M131.79 89.2696C132.273 89.2696 132.989 89.8175 133.15 90.2657C133.28 90.623 132.738 91.2121 132.471 91.6798C132.372 91.7899 132.235 91.8627 132.085 91.8839C128.28 92.7891 125.701 95.4395 122.91 97.7804C118.543 101.442 114.294 105.243 109.798 108.753C107.375 110.638 104.732 112.249 101.922 113.556C97.8833 115.427 94.9109 114.206 92.9473 110.336C92.8021 110.046 92.6525 109.758 92.4394 109.342C91.7388 110.145 91.1651 110.944 90.4442 111.594C89.1133 112.798 87.8114 114.091 86.2832 115.028C84.188 116.315 82.5958 115.461 82.3486 113.116C82.2489 112.157 82.333 111.178 82.333 109.952C81.5598 110.652 80.9516 111.209 80.3349 111.757C78.9276 113.008 77.5164 114.257 76.1016 115.503C75.8758 115.693 75.6289 115.86 75.3651 115.999C74.2677 116.594 73.136 117.216 71.8936 116.408C70.694 115.629 70.705 114.394 70.8252 113.186C70.9136 112.298 71.0878 111.416 71.2782 110.221C70.3712 110.972 69.6911 111.555 68.9882 112.118C67.1424 113.604 65.331 115.131 63.4286 116.545C62.2428 117.428 60.8118 117.896 59.2881 117.591C57.0591 117.147 56.528 115.369 56.0723 113.58C56.0254 113.328 55.9922 113.073 55.9726 112.817C55.0202 113.391 54.1928 114.02 53.2519 114.405C52.9699 114.506 52.6684 114.549 52.3681 114.531C52.0678 114.514 51.7747 114.435 51.5078 114.303C51.1839 114.11 51.0951 113.355 51.1426 112.872C51.1743 112.56 51.5965 112.222 51.9208 112.006C53.1792 111.155 54.8793 110.591 55.6299 109.45C56.3509 108.348 56.0358 106.655 56.292 105.238C57.0743 100.918 58.3083 96.7343 61.1269 93.172C61.8757 92.2281 62.8068 91.4298 63.87 90.8204C65.8473 89.7052 67.7141 90.5648 68.29 92.6827C68.8365 94.6858 68.4801 96.6174 67.6933 98.4884C65.8113 102.975 62.9023 106.797 59.2313 110.091C58.6872 110.58 58.4738 110.994 58.6279 111.661C58.7821 112.328 58.8389 113.091 59.043 113.779C59.3967 114.975 59.9777 115.253 61.1318 114.61C62.29 113.941 63.3906 113.185 64.4237 112.35C66.3805 110.834 68.2783 109.236 70.2147 107.679C70.4191 107.518 70.6374 107.373 70.8662 107.246C71.6621 106.785 72.4966 106.395 73.3877 106.967C74.317 107.567 74.4397 108.532 74.3173 109.479C74.1404 110.825 73.8362 112.16 73.5868 113.498L73.8769 113.731C74.6501 113.125 75.4642 112.56 76.1875 111.901C77.6092 110.602 78.9497 109.236 80.3827 107.954C81.3192 107.114 82.3625 106.221 83.7842 106.804C85.2059 107.386 85.0332 108.71 85.04 109.895V112.46L85.3242 112.659C86.3468 111.689 87.4418 110.78 88.3759 109.738C89.428 108.565 90.2782 107.226 91.3349 106.057C91.777 105.567 92.573 105 93.124 105.069C93.675 105.139 94.24 105.903 94.5507 106.485C94.9702 107.274 95.0941 108.199 95.4433 109.028C96.4455 111.41 98.2694 112.179 100.693 111.124C104.217 109.589 107.297 107.369 110.199 104.959C115.043 100.94 119.756 96.7799 124.606 92.7716C125.99 91.6282 127.611 90.7186 129.212 89.8546C130.005 89.4537 130.893 89.2522 131.79 89.2696ZM65.1513 93.1046C60.9133 96.5218 59.952 101.399 58.9248 106.25L59.2313 106.395C59.9115 105.552 60.6572 104.742 61.292 103.863C63.1287 101.321 64.973 98.7609 65.6465 95.6642C65.8187 94.876 65.6728 94.025 65.6728 93.2022L65.1513 93.1046Z"
          fill="currentColor"
        />
        <path
          d="M131.79 89.2696C132.273 89.2696 132.989 89.8175 133.15 90.2657C133.28 90.623 132.738 91.2121 132.471 91.6798C132.372 91.7899 132.235 91.8627 132.085 91.8839C128.28 92.7891 125.701 95.4395 122.91 97.7804C118.543 101.442 114.294 105.243 109.798 108.753C107.375 110.638 104.732 112.249 101.922 113.556C97.8833 115.427 94.9109 114.206 92.9473 110.336C92.8021 110.046 92.6525 109.758 92.4394 109.342C91.7388 110.145 91.1651 110.944 90.4442 111.594C89.1133 112.798 87.8114 114.091 86.2832 115.028C84.188 116.315 82.5958 115.461 82.3486 113.116C82.2489 112.157 82.333 111.178 82.333 109.952C81.5598 110.652 80.9516 111.209 80.3349 111.757C78.9276 113.008 77.5164 114.257 76.1016 115.503C75.8758 115.693 75.6289 115.86 75.3651 115.999C74.2677 116.594 73.136 117.216 71.8936 116.408C70.694 115.629 70.705 114.394 70.8252 113.186C70.9136 112.298 71.0878 111.416 71.2782 110.221C70.3712 110.972 69.6911 111.555 68.9882 112.118C67.1424 113.604 65.331 115.131 63.4286 116.545C62.2428 117.428 60.8118 117.896 59.2881 117.591C57.0591 117.147 56.528 115.369 56.0723 113.58C56.0254 113.328 55.9922 113.073 55.9726 112.817C55.0202 113.391 54.1928 114.02 53.2519 114.405C52.9699 114.506 52.6684 114.549 52.3681 114.531C52.0678 114.514 51.7747 114.435 51.5078 114.303C51.1839 114.11 51.0951 113.355 51.1426 112.872C51.1743 112.56 51.5965 112.222 51.9208 112.006C53.1792 111.155 54.8793 110.591 55.6299 109.45C56.3509 108.348 56.0358 106.655 56.292 105.238C57.0743 100.918 58.3083 96.7343 61.1269 93.172C61.8757 92.2281 62.8068 91.4298 63.87 90.8204C65.8473 89.7052 67.7141 90.5648 68.29 92.6827C68.8365 94.6858 68.4801 96.6174 67.6933 98.4884C65.8113 102.975 62.9023 106.797 59.2313 110.091C58.6872 110.58 58.4738 110.994 58.6279 111.661C58.7821 112.328 58.8389 113.091 59.043 113.779C59.3967 114.975 59.9777 115.253 61.1318 114.61C62.29 113.941 63.3906 113.185 64.4237 112.35C66.3805 110.834 68.2783 109.236 70.2147 107.679C70.4191 107.518 70.6374 107.373 70.8662 107.246C71.6621 106.785 72.4966 106.395 73.3877 106.967C74.317 107.567 74.4397 108.532 74.3173 109.479C74.1404 110.825 73.8362 112.16 73.5868 113.498L73.8769 113.731C74.6501 113.125 75.4642 112.56 76.1875 111.901C77.6092 110.602 78.9497 109.236 80.3827 107.954C81.3192 107.114 82.3625 106.221 83.7842 106.804C85.2059 107.386 85.0332 108.71 85.04 109.895V112.46L85.3242 112.659C86.3468 111.689 87.4418 110.78 88.3759 109.738C89.428 108.565 90.2782 107.226 91.3349 106.057C91.777 105.567 92.573 105 93.124 105.069C93.675 105.139 94.24 105.903 94.5507 106.485C94.9702 107.274 95.0941 108.199 95.4433 109.028C96.4455 111.41 98.2694 112.179 100.693 111.124C104.217 109.589 107.297 107.369 110.199 104.959C115.043 100.94 119.756 96.7799 124.606 92.7716C125.99 91.6282 127.611 90.7186 129.212 89.8546C130.005 89.4537 130.893 89.2522 131.79 89.2696ZM65.1513 93.1046C60.9133 96.5218 59.952 101.399 58.9248 106.25L59.2313 106.395C59.9115 105.552 60.6572 104.742 61.292 103.863C63.1287 101.321 64.973 98.7609 65.6465 95.6642C65.8187 94.876 65.6728 94.025 65.6728 93.2022L65.1513 93.1046Z"
          stroke="currentColor"
        />
        <path
          d="M124.816 93.5909C124.816 93.5909 129.566 74.1397 133.614 70.0831L184.832 18.7641C188.881 14.7075 195.447 14.7075 199.496 18.7641C203.544 22.8207 203.544 29.3999 199.496 33.4565L148.278 84.7755C144.229 88.8321 124.816 93.5909 124.816 93.5909Z"
          fill="white"
          stroke="currentColor"
          stroke-width="3.04348"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M192.928 50.7049L204.069 39.288L200.356 35.4824"
          stroke="currentColor"
          stroke-width="3.04348"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path
          d="M133.31 70.4166C136.852 70.0287 140.829 71.4348 143.879 74.4908C146.93 77.5483 148.319 81.5431 147.932 85.0928"
          stroke="currentColor"
          stroke-width="3.04348"
          stroke-linecap="round"
          stroke-linejoin="round"
        />
        <path d="M191.081 27.9307L174.952 44.0923" stroke="#FF531A" stroke-width="4.05797" stroke-linecap="round" />
      </g>
    </g>
    <defs>
      <clipPath id="clip0_6686_46763">
        <rect width="207" height="145" fill="white" />
      </clipPath>
    </defs>
  </svg>
</template>
